import { db } from "../firebase";
import { collection, getDocs, addDoc } from "firebase/firestore";

// Data slider default
const defaultSliders = [
  {
    judul: "Selamat Datang di SMP Muhammadiyah Bolang",
    deskripsi: "Informasi terbaru dan kegiatan sekolah",
    url: "https://via.placeholder.com/1200x400?text=Banner+1",
    urutan: 1
  },
  {
    judul: "Event Terbaru",
    deskripsi: "Jangan lewatkan kegiatan mendatang!",
    url: "https://via.placeholder.com/1200x400?text=Banner+2",
    urutan: 2
  },
  {
    judul: "Pengumuman Penting",
    deskripsi: "Info penting untuk siswa dan orang tua",
    url: "https://via.placeholder.com/1200x400?text=Banner+3",
    urutan: 3
  }
];

export const initSlider = async () => {
  const sliderRef = collection(db, "slider");
  const snapshot = await getDocs(sliderRef);

  if (snapshot.empty) {
    console.log("Slider kosong, menambahkan data default...");
    for (const slide of defaultSliders) {
      await addDoc(sliderRef, slide);
    }
    console.log("Slider default berhasil dibuat!");
  } else {
    console.log("Slider sudah ada, tidak perlu inisialisasi.");
  }
};
